import request, { Methods, withToken, RequestType } from "../../../../assets/util/request";

//* ACTIONTYPES --------------------------------------------
export const POST_FILES_TRANSPORT_RESET = 'POST_FILES_TRANSPORT_RESET';
export const POST_FILES_TRANSPORT_LOADING = 'POST_FILES_TRANSPORT_LOADING';
export const POST_FILES_TRANSPORT_SUCCESS = 'POST_FILES_TRANSPORT_SUCCESS';
export const POST_FILES_TRANSPORT_REJECT = 'POST_FILES_TRANSPORT_REJECT';

//* ACTIONS ------------------------------------------------
export const postFilesTransportReset = () => ({ type: POST_FILES_TRANSPORT_RESET });
export const postFilesTransportLoading = () => ({ type: POST_FILES_TRANSPORT_LOADING });
export const postFilesTransportSuccess = (payload) => ({ type: POST_FILES_TRANSPORT_SUCCESS, payload });
export const postFilesTransportReject = (payload) => ({ type: POST_FILES_TRANSPORT_REJECT, payload });

//* REQUEST SERVICE ---------------------------------------
export const postFilesTransportRequest = async (data, getState) => {
    const options = await withToken({
        method: Methods.POST,
        headers: RequestType.Multipart,
        data,
    }, getState);

    return request(`/Providers/web/AddProviderTransportUploadFile`, options);
};


